import React from 'react';
import { apiUrl } from './api';
import { t } from './i18n';

// ─────────────────────────────────────────────────────────────────
// Ett fel i en komponent får inte lämna en vit sida (det hände med kartan på
// profilen). Felgränsen visar ett tydligt meddelande, och alla okontrollerade
// fel rapporteras till API:t (POST /api/client-error), där de loggas som ERROR
// och larmar.
// ─────────────────────────────────────────────────────────────────

let reported = 0;
const MAX_REPORTS_PER_PAGE = 5;

export function reportClientError(kind: string, error: unknown, componentStack?: string): void {
  if (reported >= MAX_REPORTS_PER_PAGE) return;
  reported++;
  const err = error instanceof Error ? error : new Error(typeof error === 'string' ? error : JSON.stringify(error));
  try {
    const release = document.querySelector<HTMLScriptElement>('script[src*="assets/index-"]')?.src.split('/').pop();
    fetch(apiUrl('/api/client-error'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ kind, message: err.message, stack: err.stack, componentStack, url: window.location.pathname + window.location.search, release }),
      keepalive: true,
    }).catch(() => {});
  } catch { /* rapporteringen får aldrig själv krascha */ }
}

/** Fel utanför React (händelsehanterare, promises som ingen fångar). */
export function installGlobalErrorReporting(): void {
  window.addEventListener('error', e => {
    // Laddningsfel för bilder/skript har ingen error och är inte appens fel.
    if (e.error) reportClientError('window.error', e.error);
  });
  window.addEventListener('unhandledrejection', e => reportClientError('unhandledrejection', e.reason));
}

export class AppErrorBoundary extends React.Component<{ children: React.ReactNode }, { failed: boolean }> {
  state = { failed: false };
  static getDerivedStateFromError() { return { failed: true }; }
  componentDidCatch(error: unknown, info: React.ErrorInfo) {
    console.error(error);
    reportClientError('react', error, info.componentStack ?? undefined);
  }
  render() {
    if (!this.state.failed) return this.props.children;
    return (
      <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24, background: '#fff', fontFamily: 'inherit' }}>
        <div style={{ maxWidth: 420, textAlign: 'center' }}>
          <div style={{ fontSize: 22, fontWeight: 700, color: '#111', marginBottom: 10 }}>{t('appError.title')}</div>
          <div style={{ fontSize: 14, color: '#4a4a4a', lineHeight: 1.6, marginBottom: 20 }}>{t('appError.body')}</div>
          <button onClick={() => window.location.reload()}
            style={{ padding: '10px 20px', border: 'none', borderRadius: 2, background: 'hsl(var(--primary))', color: '#fff', fontSize: 12, fontWeight: 600, letterSpacing: 0.5, textTransform: 'uppercase', cursor: 'pointer' }}>
            {t('appError.reload')}
          </button>
        </div>
      </div>
    );
  }
}
